import * as React from 'react';

import EnterprisePageHeaderBffProvider from 'bundles/composable-page-header-enterprise/providers/EnterprisePageHeaderBffProvider';
import EnterpriseDomainPillsProvider from 'bundles/page-config-common/providers/enterprise-skills/EnterpriseDomainPillsProvider';
import EnterpriseSkillsProvider from 'bundles/page-config-common/providers/enterprise-skills/EnterpriseSkillsProvider';
import EnterprisePermittedProductsDataProvider from 'bundles/unified-common/providers/EnterprisePermittedProductsDataProvider';

const DefaultEnterprisePageHeaderProvider = ({ children }: { children: React.ReactNode }) => {
  return (
    <EnterprisePageHeaderBffProvider>
      <EnterpriseDomainPillsProvider>
        <EnterpriseSkillsProvider>
          <EnterprisePermittedProductsDataProvider>{children}</EnterprisePermittedProductsDataProvider>
        </EnterpriseSkillsProvider>
      </EnterpriseDomainPillsProvider>
    </EnterprisePageHeaderBffProvider>
  );
};

export default DefaultEnterprisePageHeaderProvider;
